import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';

import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ArrayManipulations } from 'app/BaseFramework/core/utilities/arrayManipulations';
import { forIn } from 'types/lodash';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}


@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.scss']
})
export class QuestionnaireComponent implements OnInit {
  _currentComponentName = "QuestionnaireComponent"

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    public commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    public lookupDataService: LookupDataService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private arrayManipulations: ArrayManipulations) { }

  //Declaraions which might need developer input
  lookupsToBind = []
  selectorOfThisComponent = 'app-questionnaire'
  parentEvent$
  environment = environment
  languageCd = this.appMetadataHandler.defaultLanguage

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE   
   */

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() transactionState: string;

  private _IO
  public _questionnaire = []
  private _receivedQuestionnaire = []
  @Input()
  set inputDataForEdit(value: any) {
    value && this.setIOAndQuestionnaire(value)
  };

  @Input()
  set IO(value) {
    value && this.setIOAndQuestionnaire(value)
  }
  setIOAndQuestionnaire(IO) {
    this._IO = this.commonUtilty.deepCopy(IO)
    this._questionnaire = IO['questionnaires']
    this._receivedQuestionnaire = this.commonUtilty.deepCopy(this._questionnaire)
    this.questionCdListFromQuestionnaire = this.getQuestionCdList(this._questionnaire)
    this.getListOfQuestionMasterCds(this.questionCdListFromQuestionnaire)
  }
  get IO() {
    return this._IO
  }

  item

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  UItoServerTransform(payload, response) {
    let questionnaire = response.componentData
    if (payload && response) {
      payload['questionnaires'] = this.commonUtilty.deepCopy(questionnaire)
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      const matches = param.filter(s => s.includes(this.getCurrentComponentName()));
      if (this.commonUtilty.isArrayIterable(param) && this.commonUtilty.isArrayIterable(matches)) {
        // let validationResult = this.validateOutput(this.claimsInsuredCoverageDecisionForm)
        let validationResult = { isInvalid: false } // remove if any customized validations to be added.
        if (!validationResult.isInvalid) {
          let output = this.convertQuestionnaireMapAndMergeToObject(this.questionnaireMap)
          this.EmitComponentOutput(output)
        }
        else {
          this.EmitComponentOutput(validationResult)
        }
      }
      else {
        console.warn(`${this.getCurrentComponentName()} recieved the ping, but is not a emitter child for current transaction type.`)
      }
    })
  }


  validateOutput(o): ValidationOutput {
    this.commonUtilty.markAllFieldDirty(o);

    let validationOutput: ValidationOutput = {
      isInvalid: null,
      errorDOs: []
    }



    if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
      validationOutput.isInvalid = true;
    }
    else {
      validationOutput.isInvalid = false;
    }

    return validationOutput
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  // Front end error list
  errorList: any = [];

  tableScrollOptions = {
    x: '500px',
    y: '460px'
  }
  insuredClientList = []
  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cQuestionnaire : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
    if (this.IO != null) this.setInsuredList();
    this.subscribeToParentEvent()
    this.extractLookupData(this.lookup$)

  }

  lookupData = {}
  extractLookupData(lookupSubjects) {
    for (const key in lookupSubjects) {
      lookupSubjects[key].subscribe(resp => {
        if (!this.lookupData[key])
          this.lookupData[key] = resp
      })
    }
  }

  private setInsuredList() {
    let extractRoles = ['PRIMARYINSURED', 'INSURED', 'OWNER', 'NOMINEE']
    extractRoles.forEach(role => {
      let extracted = this.commonUtilty.extractClientDOListFromIOGeneric(this.IO, role);
      this.insuredClientList.push(...extracted)
    })
    this.insuredClientList = this.arrayManipulations.getUniqueElements(this.insuredClientList, 'id')
    this.tableScrollOptions.x = `${400 + (this.insuredClientList.length * 120)}px`;
  }

  questionCdListFromQuestionnaire = []
  questionCdListFromQuestionnaireWithLeadingQuestions = []
  getQuestionCdList(questionnaire) {
    let questionCdList = []
    if (this.commonUtilty.isArrayIterable(questionnaire)) {
      questionnaire.forEach(questionItem => {
        if (this.commonUtilty.isArrayIterable(questionItem.questionnaireDtls)) {
          questionItem.questionnaireDtls.forEach(questionnaireDtl => {
            if (questionnaireDtl.questionCd)
              questionCdList.push(questionnaireDtl.questionCd)
          });
        }
      });
    }
    return questionCdList
  }

  questionnaireMap
  createQuestionnaireMap(_questionnaire) {
    let questionnaireMap = this.commonUtilty.convertArrayToMap(_questionnaire, 'clientRefGuid')
    for (const key in questionnaireMap) {
      questionnaireMap[key]['questionnaireDtlsMap'] = this.commonUtilty.convertArrayToMap(questionnaireMap[key]['questionnaireDtls'], 'questionCd')
    }
    return questionnaireMap
  }

  convertQuestionnaireMapAndMergeToObject(questionnaireMap) {
    let originalRecievedQuestionnaire = this.commonUtilty.deepCopy(this._receivedQuestionnaire)
    for (const key in questionnaireMap) {
      questionnaireMap[key]['questionnaireDtls'] = this.commonUtilty.convertMapToArray(questionnaireMap[key]['questionnaireDtlsMap'])
    }

    let output = this.commonUtilty.convertMapToArray(questionnaireMap)

    if (this.commonUtilty.isArrayIterable(output)) {
      output.forEach((q, i) => {
        delete output[i]['questionnaireDtlsMap']
        if (this.commonUtilty.isArrayIterable(output[i]['questionnaireDtls'])) {
          q['questionnaireDtls'].forEach((qdtls, idtls) => {
            delete output[i]['questionnaireDtls'][idtls]['QuestionMasterDO']
          });
        }

        if (this.commonUtilty.isArrayIterable(originalRecievedQuestionnaire)) {
          originalRecievedQuestionnaire.forEach((questionnaire, index) => {
            if (questionnaire.appliesToCd == q.appliesToCd && questionnaire.clientRefGuid == q.clientRefGuid) {
              originalRecievedQuestionnaire[index] = this.commonUtilty.deepCopy(q)
            }
          });
        }
      })
    }



    return originalRecievedQuestionnaire
  }

  emptyQuestionnaireDtlDO = {
    "baseCompanyCd": null,
    "versionNum": null,
    "caseManager": null,
    "questionnaireCd": null,
    "questionCd": null,
    "responseCd": null,
    "responseDtl": null,
    "objectName": "QuestionnaireDtlDO"
  }

  listOfQuestionMasterCds = []
  dataset = []
  getListOfQuestionMasterCds(listOfQuestionCds) {
    // get call for QuestionMasterDO
    const payload = {
      "params": listOfQuestionCds // send the questionCd
    }
    this.apiRequestService.postCallWithAPIMapper('fetchByQuestionCd', payload).subscribe(resp => {
      if (this.commonUtilty.isArrayIterable(resp)) {
        this.listOfQuestionMasterCds.push(...resp)
        this.listOfQuestionMasterCds = this.arrayManipulations.getUniqueElements(this.listOfQuestionMasterCds, 'questionCd')
        this.dataset = this.listOfQuestionMasterCds
        let listOfLeadingQuestionCd: Array<any> = this.getListOfLeadingQuestionCds(this.listOfQuestionMasterCds)
        let uniqueListOfLeadingQuestionCd = Array.from(new Set(listOfLeadingQuestionCd))
        if (this.commonUtilty.isArrayIterable(uniqueListOfLeadingQuestionCd)) {
          this.getListOfQuestionMasterCds(uniqueListOfLeadingQuestionCd)
        }
        else {
          //Contextual Call, cannot be used anywhere else in the code.
          this.generateQuestionnaireMap();
        }
      }
      else {
        //Contextual Call, cannot be used anywhere else in the code.
        this.generateQuestionnaireMap();
      }
      if(this.commonUtilty.isArrayIterable(this.insuredClientList) && this.insuredClientList.length){
        this.insuredClientList.forEach(client =>{
          if(this.commonUtilty.isArrayIterable(this.listOfQuestionMasterCds) && this.listOfQuestionMasterCds.length){
            this.listOfQuestionMasterCds.forEach(questionMasterDO =>{
              if(this.questionnaireMap && this.questionnaireMap[client.guid] && this.questionnaireMap[client.guid]['questionnaireDtlsMap'] && this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd] && this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].responseTypeCd == 'RADIO')
                this.setLeadingFlagForQuestion(questionMasterDO.questionCd, this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd);
              else this.setLeadingFlagForQuestion(questionMasterDO.questionCd, 'YES');
            })
          }

        })
      }
    });

  }

  setLeadingFlagForQuestion(questionCd?, leadingQuesResponse?){
    if(questionCd){
      this.listOfQuestionMasterCds.forEach(questionMasterDO =>{
        if(questionCd == questionMasterDO.leadingQuestionCd && leadingQuesResponse == 'YES') {
          questionMasterDO['isSubQuestionVisible'] = true;
        }
        else if(questionCd == questionMasterDO.leadingQuestionCd && (!leadingQuesResponse || leadingQuesResponse == 'NO')) {
          questionMasterDO['isSubQuestionVisible'] = false;
        } else {
          questionMasterDO['isSubQuestionVisible'] = false;
        }
        console.log("leading question res = ", leadingQuesResponse);
      })
    }
    else{
      if(this.commonUtilty.isArrayIterable(this.listOfQuestionMasterCds) && this.listOfQuestionMasterCds.length){
        this.listOfQuestionMasterCds.forEach(questionMasterDO =>{
          if(this.commonUtilty.isArrayIterable(this.insuredClientList) && this.insuredClientList.length){
            this.insuredClientList.forEach(client =>{
              if(this.questionnaireMap && this.questionnaireMap[client.guid] && this.questionnaireMap[client.guid]['questionnaireDtlsMap'] && 
                this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd] && 
                this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'] &&
                this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd &&
                this.questionnaireMap[client.guid]['questionnaireDtlsMap'][this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd] &&
                this.questionnaireMap[client.guid]['questionnaireDtlsMap'][this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd].responseCd == 
                this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuesResponseCd){
                  questionMasterDO['isSubQuestionVisible'] = true;

              // if(this.questionnaireMap && this.questionnaireMap[client.guid] && this.questionnaireMap[client.guid]['questionnaireDtlsMap'] && this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].responseTypeCd == 'RADIO' && this.questionnaireMap[client.guid]['questionnaireDtlsMap'][this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].leadingQuestionCd]){
              //   questionMasterDO['isSubQuestionVisible'] = this.questionnaireMap[client.guid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'].captureDtlForResCd == 'YES' ? true : false;
              
              }
              else questionMasterDO['isSubQuestionVisible'] = false;
            })
          }
        })
      }
    }
    console.log("this.questionnaireMap", this.listOfQuestionMasterCds);
  }

  questionAnswerMap;
  private generateQuestionnaireMap() {
    this.questionCdListFromQuestionnaireWithLeadingQuestions = this.stitchQuestionMasterDOsAndLeadingQuestions(this._questionnaire, this.listOfQuestionMasterCds);
    this.listOfQuestionMasterCds = this.sortListOfQuestionMasterCds(this.listOfQuestionMasterCds);
    this.questionnaireMap = this.createQuestionnaireMap(this.questionCdListFromQuestionnaireWithLeadingQuestions);
    this.questionAnswerMap = this.generateQnA_resp();
    console.log('listOfQuestionMasterCds', JSON.stringify(this.listOfQuestionMasterCds));
  }

  stitchQuestionMasterDOsAndLeadingQuestions(questionnaire, listOfQuestionMasterCds) {
    if (this.commonUtilty.isArrayIterable(questionnaire) && this.commonUtilty.isArrayIterable(listOfQuestionMasterCds)) {
      questionnaire.forEach((questionnaireItem, questionnaireIndex) => {

        if (this.commonUtilty.isArrayIterable(questionnaireItem.questionnaireDtls)) {
          questionnaireItem.questionnaireDtls.forEach((questionnaireDtlItem, qDtlIndex) => {

            let questionMasterDOItem = listOfQuestionMasterCds.find(e => questionnaireDtlItem.questionCd == e.questionCd)
            if (questionMasterDOItem) {
              questionMasterDOItem['questionMsgDOMap'] = this.commonUtilty.deepCopy(this.commonUtilty.convertArrayToMap(questionMasterDOItem['questionMsgDO'], 'languageCd'))
              questionnaire[questionnaireIndex]['questionnaireDtls'][qDtlIndex]['QuestionMasterDO'] = this.commonUtilty.deepCopy(questionMasterDOItem) || {}


              // if (questionMasterDOItem.leadingQuestionCd && !this.commonUtilty.hasNumber(questionMasterDOItem.leadingQuestionCd)) {
              //   let newQuestionnaireDtlItem = this.commonUtilty.deepCopy(this.emptyQuestionnaireDtlDO)
              //   newQuestionnaireDtlItem.questionCd = questionMasterDOItem.leadingQuestionCd
              //   newQuestionnaireDtlItem.questionnaireCd = questionMasterDOItem.questionnaireCd || console.error(`QuestionnaireCd found Empty ${questionMasterDOItem}`);
              //   let leadingQMasterDOIndex = questionnaire[questionnaireIndex]['questionnaireDtls'].findIndex(qm => qm.questionCd == newQuestionnaireDtlItem.questionCd)
              //   if (leadingQMasterDOIndex == -1)
              //     questionnaire[questionnaireIndex]['questionnaireDtls'].splice(qDtlIndex, 0, newQuestionnaireDtlItem)
              // }
            }
            else {
              console.warn("This QuestionMasterDO not Fetched", questionnaireItem)
              console.log(`Check ${questionnaireDtlItem.questionCd}`, JSON.stringify(listOfQuestionMasterCds));
            }
          });
        }
      });
    }
    return questionnaire
  }


  sortListOfQuestionMasterCds(listOfQuestionMasterCds) {
    if (listOfQuestionMasterCds && this.commonUtilty.isArrayIterable(listOfQuestionMasterCds)) {
      listOfQuestionMasterCds.forEach((masterQuestionDO, currentIndex) => {
        if (masterQuestionDO && masterQuestionDO.leadingQuestionCd) {
          let parentIndex = listOfQuestionMasterCds.findIndex(e => e.questionCd == masterQuestionDO.leadingQuestionCd)
          listOfQuestionMasterCds = this.insertAndShift(listOfQuestionMasterCds, currentIndex, parentIndex + 1)
        }
      });
    }
    let lastParentIndex = 0
    listOfQuestionMasterCds.forEach((QuestionDO, index) => {
      if (!QuestionDO.leadingQuestionCd) {
        QuestionDO['questionNumber'] = lastParentIndex + 1
        lastParentIndex = lastParentIndex + 1
      }
      listOfQuestionMasterCds[index]['questionMsgDOMap'] = this.commonUtilty.convertArrayToMap(listOfQuestionMasterCds[index]['questionMsgDO'], 'languageCd')
    })


    return listOfQuestionMasterCds
  }

  getListOfLeadingQuestionCds(listOfQuestionMasterCds) {
    let output = []
    if (this.commonUtilty.isArrayIterable(listOfQuestionMasterCds)) {
      listOfQuestionMasterCds.forEach(questionMasterDO => {
        let isLeadingQuestionCdPresent = listOfQuestionMasterCds.some(qm => qm.questionCd == questionMasterDO.leadingQuestionCd)
        if (questionMasterDO.resLookupCd)
          this.addNewLookup(questionMasterDO.resLookupCd);
        if (!isLeadingQuestionCdPresent) {
          output.push(questionMasterDO.leadingQuestionCd)
        }
      });
    }
    let uniqueOutput = Array.from(new Set(output))
    uniqueOutput = Array.isArray(uniqueOutput) ? uniqueOutput.filter(e => e) : []
    return uniqueOutput
  }

  private addNewLookup(resLookupCd: any) {
    this.lookup$ = Object.assign({}, this.lookup$, this.commonUtilty.initializeLookupList([resLookupCd]));
    this.extractLookupData(this.lookup$);
  }

  insertAndShift(arr, from, to) {
    let cutOut = arr.splice(from, 1)[0]; // cut the element at index 'from'
    arr.splice(to, 0, cutOut); // insert it at index 'to'
    return arr
  }

  selectAllValueForGivenClient(clientRefGuid) {

    if (this.commonUtilty.isArrayIterable(this.listOfQuestionMasterCds)) {
      this.listOfQuestionMasterCds.forEach(questionMasterDO => {
        
        if (this.questionnaireMap && this.questionnaireMap[clientRefGuid] && this.questionnaireMap[clientRefGuid].appliesToCd == "CLIENT") {
          if (this.questionnaireMap[clientRefGuid]['questionnaireDtlsMap'][questionMasterDO.questionCd] &&
            this.questionnaireMap[clientRefGuid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO']) {

            let questionnaireMasterDoLeadingQuestionCd = this.questionnaireMap[clientRefGuid]['questionnaireDtlsMap'][questionMasterDO.questionCd]['QuestionMasterDO'];
            if ((questionnaireMasterDoLeadingQuestionCd.leadingQuestionCd &&
              this.questionnaireMap[clientRefGuid]['questionnaireDtlsMap'][questionnaireMasterDoLeadingQuestionCd.leadingQuestionCd] &&
              this.questionnaireMap[clientRefGuid]['questionnaireDtlsMap'][questionnaireMasterDoLeadingQuestionCd.leadingQuestionCd].responseCd == questionnaireMasterDoLeadingQuestionCd.leadingQuesResponseCd) ||
              (questionnaireMasterDoLeadingQuestionCd && !!!questionnaireMasterDoLeadingQuestionCd.leadingQuestionCd)) {

              if (questionnaireMasterDoLeadingQuestionCd.responseTypeCd == 'LOOKUP' || questionnaireMasterDoLeadingQuestionCd.responseTypeCd == 'RADIO') {
                this.setLeadingFlagForQuestion(questionMasterDO.questionCd,this.questionnaireMap[clientRefGuid]['selectAllForClient'])
                // questionMasterDO['isSubQuestionVisible'] = this.questionnaireMap[clientRefGuid]['selectAllForClient'] == 'YES' ? true : false;
                this.questionnaireMap[clientRefGuid]['questionnaireDtlsMap'][questionMasterDO.questionCd].responseCd = this.questionnaireMap[clientRefGuid]['selectAllForClient'];

              }

            }
          }
        }
      });
    }
  }

  generateQnA_resp() {
  const simplifiedResponses = {};

  for (const key in this.questionnaireMap) {
    if (this.questionnaireMap.hasOwnProperty(key)) {
      const questionnaireDtls = this.questionnaireMap[key].questionnaireDtls;

      questionnaireDtls.forEach((item: any) => {
        if (
          item &&
          item.QuestionMasterDO &&
          item.QuestionMasterDO.questionMsgDOMap &&
          item.QuestionMasterDO.questionMsgDOMap['EN'] &&
          item.QuestionMasterDO.questionMsgDOMap['EN'].message
        ) {
          const question = item.QuestionMasterDO.questionMsgDOMap['EN'].message;
          const response = item.responseCd;
          if(!simplifiedResponses[key]) simplifiedResponses[key]= [];
          simplifiedResponses[key].push({
            //id: key,
            question,
            response
          });
        }
      });
    }
  }

  return simplifiedResponses;
}

  questionMasterDO =
    {
      "parentObject": null,
      "versionId": 1,
      "guid": "a3583a84-1e4a-4676-a513-d84756769c08",
      "createdDt": 1542108538282,
      "updatedDt": 1542113118211,
      "createdUser": "ADMIN",
      "updatedUser": "ADMIN",
      "baseCompanyCd": null,
      "versionNum": null,
      "caseManager": null,
      "exceptionDOList": null,
      "id": 1,
      "questionCd": "Q1_DIABETES",
      "description": "Have you ever had diabetes hypoglycemia, basedow, hypothyroidism, thyroid / thyroid disease, fat metabolism, Gout, myasthenia?",
      "responseTypeCd": "RADIO",
      "resLookupCd": "booleanYNCd",
      "captureDtlForResCd": "NO",
      "questionnaireCd": "GENERAL",
      "triggerCd": "ALWAYS",
      "leadingQuestionCd": null,
      "leadingQuesResponseCd": null,
      "leadingQuestionFl": "NO",
      "sortOrder": 1,
      "title": null,
      "vocabularyCd": null,
      "questionMsgDO": [],
      "objectName": "QuestionMasterDO"
    }

  skjdnf = {
    234324: {
      "parentObject": null,
      "versionId": 1,
      "guid": "69521e2d-7e64-48b5-97c3-f79bb34e4206",
      "createdDt": 1586618715554,
      "updatedDt": 1586618715554,
      "createdUser": "DE",
      "updatedUser": "DE",
      "baseCompanyCd": null,
      "versionNum": null,
      "caseManager": null,
      "id": 1,
      "entityGuid": null,
      "appliesToCd": "CLIENT",
      "clientRefGuid": null,
      "questionnaireCd": "CHILD",
      "questionnaireDtls": [
        {
          "parentObject": null,
          "versionId": null,
          "guid": "0e1e6bc8-691c-42ce-bb76-2504fadb46e3",
          "createdDt": 1586618715606,
          "updatedDt": 1586618715606,
          "createdUser": "DE",
          "updatedUser": "DE",
          "baseCompanyCd": null,
          "versionNum": null,
          "caseManager": null,
          "id": 1,
          "questionnaireCd": "CHILD",
          "questionCd": "Q7_BIRTH_UNCERTAINTIES",
          "responseCd": null,
          "responseDtl": null,
          "objectName": "QuestionnaireDtlDO"
        },
        {
          "parentObject": null,
          "versionId": null,
          "guid": "dd023af9-1e3e-4131-a4fa-4eb5c3852acc",
          "createdDt": 1586618715649,
          "updatedDt": 1586618715649,
          "createdUser": "DE",
          "updatedUser": "DE",
          "baseCompanyCd": null,
          "versionNum": null,
          "caseManager": null,
          "id": 2,
          "questionnaireCd": "CHILD",
          "questionCd": "Q8_VACCINATION",
          "responseCd": null,
          "responseDtl": null,
          "objectName": "QuestionnaireDtlDO"
        },
        {
          "parentObject": null,
          "versionId": null,
          "guid": "b74ed493-7a09-428f-9539-9da51c40738b",
          "createdDt": 1586618715696,
          "updatedDt": 1586618715696,
          "createdUser": "DE",
          "updatedUser": "DE",
          "baseCompanyCd": null,
          "versionNum": null,
          "caseManager": null,
          "id": 3,
          "questionnaireCd": "CHILD",
          "questionCd": "Q9_ABNORMAL_CHILD",
          "responseCd": null,
          "responseDtl": null,
          "objectName": "QuestionnaireDtlDO"
        }
      ],
      "objectName": "QuestionnaireDO"
    }
  }
  
  originalList : any[]
  list: any[] ;
  filter: string
  questionFilter(list: any[], filter: string){
    if (!filter) {
      return list;
    }
    return list.filter(item => item.questionMsgDOMap?.[this.languageCd]?.message.toLowerCase().includes(filter.toLowerCase()));
  }

  questionSearch: string;
  searchTableData(searchValue){
    this.questionSearch = searchValue;
    this.listOfQuestionMasterCds = this.questionFilter(this.listOfQuestionMasterCds, this.questionSearch);
  }
  reset(){
    this.questionSearch = '';
    this.listOfQuestionMasterCds = this.dataset
  }
}
